function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties(source, excluded) {
  if (source == null) return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import { Link } from "@custom/schema";
import clsx from "clsx";
import React from "react";
export var Button = function Button(_param) {
  var text = _param.text,
    _param_disabled = _param.disabled,
    disabled = _param_disabled === void 0 ? false : _param_disabled,
    _param_variant = _param.variant,
    variant = _param_variant === void 0 ? "primary" : _param_variant,
    _param_size = _param.size,
    size = _param_size === void 0 ? "large" : _param_size,
    icon = _param.icon,
    children = _param.children,
    _param_isFullWidth = _param.isFullWidth,
    isFullWidth = _param_isFullWidth === void 0 ? false : _param_isFullWidth,
    _param_groupHover = _param.groupHover,
    groupHover = _param_groupHover === void 0 ? false : _param_groupHover,
    props = _object_without_properties(_param, ["text", "disabled", "variant", "size", "icon", "children", "isFullWidth", "groupHover"]);
  var Wrapper = props.isDecorative ? "div" : props.href ? Link : "button";
  var _props_href;
  return /*#__PURE__*/React.createElement(Wrapper, _object_spread_props(_object_spread({
    href: (_props_href = props.href) !== null && _props_href !== void 0 ? _props_href : ""
  }, props.href && {
    target: props.openInNewTab ? "_blank" : undefined,
    rel: props.openInNewTab ? "noopener noreferrer" : undefined
  }, props.href == undefined && !props.isDecorative && {
    type: props.buttonType || "button",
    onClick: props.onClick,
    disabled: disabled
  }), {
    className: clsx("font-juneau !border-0 text-left inline-flex items-center justify-center gap-2 transition-colors duration-300 ease-in-out rounded-full  hover:bg-primary-dark-grey hover:!text-primary-white disabled:bg-primary-black-20 disabled:cursor-not-allowed disabled:!text-primary-white cursor-pointer disabled:!outline-primary-black-20", {
      "group-hover:bg-primary-dark-grey group-hover:text-primary-white": groupHover,
      "w-full": isFullWidth,
      "w-fit": !isFullWidth,
      "bg-theme-action !text-theme-text": variant === "primary",
      "bg-primary-white text-theme-action": variant === "primary-reverse",
      "!text-primary-dark-grey disabled:!text-primary-white outline-primary-dark-grey outline outline-2 -outline-offset-2 focus-visible:!outline-double focus-visible:!outline-[6px] focus-visible:!outline-primary-dark-grey focus-visible:!-outline-offset-2": variant === "primary-light" || variant === "secondary",
      "bg-transparent": variant === "primary-light",
      "bg-primary-white": variant === "secondary" || variant === "secondary-no-border",
      "bg-monetary !text-primary-white": variant === "monetary",
      "bg-primary-dark-grey !text-primary-white hover:!bg-primary-black": variant === "dark",
      "px-8 py-4 text-16 leading-100% min-h-14": size === "large",
      "px-6 py-3 text-14 leading-100%  min-h-12": size === "medium",
      "px-4.5 py-3 text-14 leading-100% min-h-10 ": size === "small",
      "px-4 py-3 text-12 gap-1.5 leading-100% min-h-9": size === "extra-small"
    })
  }), icon && /*#__PURE__*/React.createElement("div", {
    className: clsx("flex items-center", {
      "h-4": size === "small",
      "h-3": size === "extra-small"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx("flex items-center", {
      "h-6 w-6": size === "large" || size === "medium",
      "h-5 w-5": size === "small",
      "h-4.5 w-4.5": size === "extra-small"
    })
  }, icon)), text, children);
};